import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as studentActions from '@app/actions/students'
import PreparatoryStart from '@app/components/students/Start/Preparatory'
import TrialStart from '@app/components/students/Start/Trial'
import MainStart from '@app/components/students/Start/Main'

class Start extends Component {
  render() {
    const { route: { match: { params: { tour } } } } = this.props

    switch (tour) {
    case 'preparatory':
      return <PreparatoryStart {...this.props} />;
    case 'trial':
      return <TrialStart {...this.props} />;
    case 'main':
      return <MainStart {...this.props} />;
    }
  }
}

const mapStateToProps = (state) => {
  const { students: { participate } } = state;
  return { participate }
}

const mapDispatchToProps = (dispatch) => {
  const boundStudentActions = bindActionCreators(studentActions, dispatch)
  return { boundStudentActions }
}

Start.propTypes = {
  route: PropTypes.object.isRequired
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null, {
    getDisplayName: () => 'Start'
  }
)(Start)
